import { Sentry } from '@wix/editor-error-reporter/dist/getSentry';
import type * as SentryTypes from '@sentry/browser';

export class CustomTransport extends Sentry.Transports.FetchTransport {
  sendEvent(event: SentryTypes.Event): PromiseLike<SentryTypes.Response> {
    return super.sendEvent(event);
  }
}
